import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import { Env } from "./utils/env.utils";

Sentry.init({
	dsn: Env.getInstance().sentryDsn,
	// Setting this option to true will send default PII data to Sentry.
	// For example, automatic IP address collection on events
	sendDefaultPii: true,
});

Sentry.replayIntegration({
	maskAllText: false,
});

// biome-ignore lint/style/noNonNullAssertion: <explanation>
ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
